/**
 * Created by Youhn on 2017/12/14.
 */
import { jwtSecret } from './../config/env'
let jwt = require('jwt-simple')
export function setCookie (name, value, minutes) {
  let exp = new Date()
  exp.setTime(exp.getTime() + minutes * 60 * 1000)
  document.cookie = name + '=' + escape(value) + ';expires=' + exp.toGMTString()
}
export function getCookie (name) {
  let arr
  let reg = new RegExp('(^| )' + name + '=([^;]*)(;|$)')
  if (arr = document.cookie.match(reg)) {
    return unescape(arr[2])
  } else {
    return null
  }
}
export function setItem (name, param, minute) {
  param.exp = new Date().getTime() + (minute || 24 * 60) * 60 * 1000
  param.name = escape(param.name)
  let token = jwt.encode(param, jwtSecret)
  // localStorage.setItem(name, token)
  // token缓存改为cookie,有效时间24小时
  setCookie(name, token, 60*2)
}
export function getItem (name) {
  localStorage.removeItem('zds_user');//清除老用户的localStorage
  localStorage.removeItem('ZDS_Store');//清除老用户的localStorage
  // let userId = localStorage.getItem(name)
  let userId = getCookie(name)
  if (userId) {
    // console.log(jwt.decode(userId, jwtSecret))
    return jwt.decode(userId, jwtSecret)
  }
  return null
}
export function isLogin () {
  if (getItem('zds_user')) {
    return true
  }
  return false
}
export function setToken (value) {
  setItem('zds_user', value, 60 * 24)
}
export function getToken (value) {
  let user = getItem('zds_user')
  if (!user || user.exp <= Date.now()) {
    return null
  }
  return user.uid
}



// WEBPACK FOOTER //
// ./src/util/jwtAuth.js